import {GenericList} from './GenericList';
import {Document} from "../../models/Document";
import {BaseDocument} from "../../dms/definitions/BaseDocument";

export class DocumentList extends GenericList<Document> {}
